// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"index_dropdown_1fupo","icon":"index_icon_1wGRI","title":"index_title_2i_3U"};